"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
const index_js_1 = require("../atom/index.js");
let map = (value = {}) => {
    let store = (0, index_js_1.atom)(value);
    store.setKey = function (key, newValue) {
        if (typeof newValue === 'undefined') {
            if (key in store.value) {
                store.value = { ...store.value };
                delete store.value[key];
                store.notify(key);
            }
        }
        else if (store.value[key] !== newValue) {
            store.value = {
                ...store.value,
                [key]: newValue
            };
            store.notify(key);
        }
    };
    return store;
};
exports.map = map;
